import { baseURLWSocket } from '../config/config'
import { updateViews } from './webSocketMethods'
import { WEBSOCKET_TYPES } from './Constants'
import { PostsServices } from '../../database/posts.database'

// class WebSocketSingleton {

//     static instance = null;
//     static ws = null;
//     static reconnectAttempts = 0;
//     static listeners = [];
//     // static isConnecting = false;

//     static  getInstance(apiUrlWSocket) {
//         if ((!this.instance || Object.keys(this.instance).length == 0) && apiUrlWSocket) {
//             this.instance = new WebSocketSingleton();
//             this.connect(apiUrlWSocket);
//         }
//         return WebSocketSingleton.instance;
//     }

//     constructor() {
//         if (!WebSocketSingleton.instance) {
//             this.ws = null;
//             WebSocketSingleton.instance = this;
//         }
//         return WebSocketSingleton.instance;
//     }
//     static connect(apiUrlWSocket) {
//         if (!apiUrlWSocket) return;

//         // WebSocketSingleton.isConnecting = true;
//         if (this.ws == null) {
//             this.ws = new WebSocket(apiUrlWSocket);
//             

//             this.ws.addEventListener('open', () => {
//                 
//                 

//                 this.reconnectAttempts = 0;
//                 // WebSocketSingleton.isConnecting = false;
//                 this.notifyListeners('open');
//             });

//             this.ws.addEventListener('message', async (event) => {
//                 
//                 const data = JSON.parse(event.data);
//                 await handleMessage(data);
//                 this.notifyListeners('message', data);
//             });

//             this.ws.addEventListener('error', (error) => {
//                 console.error('Error en la conexión del WebSocket:', error);
//                 // WebSocketSingleton.isConnecting = false;
//                 this.reconnect(apiUrlWSocket);
//                 this.notifyListeners('error', error);
//             });

//             this.ws.addEventListener('close', () => {
//                 
//                 // WebSocketSingleton.isConnecting = false;
//                 this.reconnect(apiUrlWSocket);
//                 this.notifyListeners('close');
//             });
//         }
//     }

//     static reconnect(apiUrlWSocket) {
//         
//         const delay = Math.min(3000 + this.reconnectAttempts * 5000, 30000); // max delay of 30 seconds

//         setTimeout(() => {
//             this.reconnectAttempts++;
//             this.connect(apiUrlWSocket);
//         }, delay);
//     }

//     static notifyListeners(eventType, data) {
//         this.listeners.forEach(listener => {
//             if (listener.event === eventType) {
//                 listener.callback(data);
//             }
//         });
//     }

//     addListener(event, callback) {
//         this.listeners.push({ event, callback });
//     }

//     removeListener(event, callback) {
//         const index = this.listeners.findIndex(listener => listener.event === event && listener.callback === callback);
//         if (index !== -1) {
//             this.listeners.splice(index, 1);
//         }
//     }

//     sendMessage(data, type, token) {
//         const dataToSend = data.filter(item => item["_id"] != null);
//         const result = {
//             type: type,
//             data: dataToSend,
//             token: token
//         };

//         return new Promise((resolve, reject) => {
//             

//             if (this.ws && this.ws.readyState === WebSocket.OPEN) {
//                 try {
//                     this.ws.send(JSON.stringify(result));
//                     
//                     resolve(); // Resuelve la promesa aquí
//                 } catch (error) {
//                     console.error("Error al enviar los datos", error);
//                     reject(error);
//                 }
//             } else {
//                 console.error("WebSocket no está abierto, intentando reconectar...");
//             }
//         });
//     }
// }

// export default WebSocketSingleton;

// /**
//  * @description Genera la URL de WebSocket del usuario
//  * @param {*} nameGroup
//  * @param {*} user_id
//  * @param {*} device
//  * @returns {string} URL de conexión
//  */
export const generateWebSocketUrl = (nameGroup, user_id, device) => {
    const urlParams = new URLSearchParams({
        name_group: nameGroup,
        user: user_id,
        device: device,
    })

    console.log('🔧 [WebSocketContext] Setting up WebSocket')

    const wsUrl = `${baseURLWSocket}?${urlParams.toString()}`

    return wsUrl
}

class WebSocketSingleton {
    constructor(apiUrlWSocket) {
        if (!WebSocketSingleton.instance) {
            this.url = apiUrlWSocket
            this.socket = null
            this.isConnected = false
            this.eventListeners = {}
            this._connectTs = Date.now()

            WebSocketSingleton.instance = this
            this.initWebSocket()
        }
        return WebSocketSingleton.instance
    }

    initWebSocket() {
        try {
            this.socket = new WebSocket(this.url)

            this.socket.onopen = () => {
                this.isConnected = true
                this.dispatchEvent('open')
            }

            this.socket.onmessage = async (message) => {
                try {
                    console.log('🔴 [WS] onmessage FIRED at', new Date().toISOString(), 'raw:', message?.data)

                    const raw = message?.data
                    let data = null
                    try { 
                        data = typeof raw === 'string' ? JSON.parse(raw) : raw 
                    } catch (e){
                        console.error('[WS] onmessage JSON.parse error for data:', raw, e)
                    }

                    const type = data?.type || 'message'
                    console.log('🟢 [WS] onmessage TYPE:', type)
                    // Log acotado
                    // if (type === 'POSTS_VIEWEDS') {
                    //     console.log('[WS][recv][POSTS_VIEWEDS] count=', (data?.posts || []).length)
                    // } else {
                    //     console.log('[WS][recv]', type)
                    // }
                    // ✅ Log detallado para POSTS_VIEWEDS
                    if (type === 'POSTS_VIEWEDS') {
                        console.log('[WS][recv][POSTS_VIEWEDS] Full data:', {
                            count: (data?.posts || []).length,
                            posts: data?.posts?.slice(0, 3), // Primeros 3 posts para ver estructura
                            timestamp: new Date().toISOString()
                        })
                    } else {
                        console.log('[WS][recv]', type)
                    }
                    this.dispatchEvent(type, message.data)
                } catch (e) {
                    console.warn('[WS] onmessage parse error', e?.message)
                }

            }

            this.socket.onclose = () => {
                this.isConnected = false
                this.dispatchEvent('close')
                setTimeout(() => {
                    console.log('[WS] reconnecting...')
                    this.initWebSocket()
                }, 5000)
            }

            this.socket.onerror = (error) => {
                console.error('[WS] error:', error?.message || error)
                this.dispatchEvent('error', error)
            }
        } catch (error) {
            console.error('[WS] init error:', error?.message || error)
        }
    }

    send(data, type, token) {
        return new Promise((resolve, reject) => {

            console.log('📤 [WS] ATTEMPTING TO SEND')

            if (this.socket && this.socket.readyState === this.socket.OPEN) {
                const dataToSend = data.filter((item) => item['_id'] != null)
                const result = {
                    type: type,
                    data: dataToSend,
                    token: token,
                }

                console.log('📦 [WS] MESSAGE PAYLOAD')

                try {
                    this.socket.send(JSON.stringify(result))
                    console.log('✅ [WS] Message SENT successfully')
                    resolve('Message sent successfully')
                } catch (e) {
                    console.error('❌ [WS] Send FAILED:', e)
                    return reject(e)
                }
                resolve('Message sent successfully')
            } else {
                const rs = this.socket ? this.socket.readyState : -1
                // console.warn('[WS][send] not connected, readyState=', rs)

                console.warn('⚠️ [WS] Cannot send - Not connected')
                console.warn('ReadyState:', rs)
                reject('WebSocket is not connected')
            }
        })
    }

    getReadyState() {
        return this.socket ? this.socket.readyState : -1
    }

    addEventListener(event, listener) {
        if (!this.eventListeners[event]) {
            this.eventListeners[event] = []
        }
        this.eventListeners[event].push(listener)
    }

    removeEventListener(event, listener) {
        if (this.eventListeners[event]) {
            this.eventListeners[event] = this.eventListeners[event].filter((l) => l !== listener)
        }
    }

    dispatchEvent(event, data) {
        if (this.eventListeners[event]) {
            this.eventListeners[event].forEach((listener) => listener(data))
        }
    }
}

// Function to initialize the singleton instance with WebSocket URL
async function initializeWebSocketInstance(apiUrlSocket) {

    if (!apiUrlSocket) return
    const webSocketInstance = new WebSocketSingleton(apiUrlSocket)
    return webSocketInstance
}

export default initializeWebSocketInstance

const handleMessage = async (data) => {
    try {
        switch (data.type) {
            case WEBSOCKET_TYPES.POSTS_VIEWEDS:
                await updateViews(data.posts)
                break
            case WEBSOCKET_TYPES.BENEFIT:
                break
            case WEBSOCKET_TYPES.BENEFIT_REDEEM:
                break
            default:
                break
        }
    } catch (error) {
        console.error('Error:', error)
    }
}
